module.exports = __webpack_public_path__ + "img/INBooks-1024x328.94f61b75.png";